module.exports = __webpack_public_path__ + "img/box-clouds-4.acf1c997.png";